import { render, staticRenderFns } from "./index-malaysia.vue?vue&type=template&id=8ff34028&scoped=true&"
import script from "./index-malaysia.vue?vue&type=script&lang=ts&"
export * from "./index-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./index-malaysia.vue?vue&type=style&index=0&id=8ff34028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff34028",
  null
  
)

export default component.exports